import { Component } from '@angular/core';

@Component({
  selector: 'app-write-article',
  templateUrl: './write-article.component.html',
  styleUrls: ['./write-article.component.css'],
})
export class WriteArticleComponent {
  title1 = 'Admin Panel';
  title3 = 'My Article';
  title = 'Write <span>Article</span>';
  class1 = 'profile-banner ';
  img1 = '../../../assets/images/logo.png';
}
